module.exports = __webpack_public_path__ + "static/img/02560_9.9e5667a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02560_9.jpg
// module id = 0ZcR
// module chunks = 1